import {
  List,
  Datagrid,
  TextField,
  DateField,
  ListActions,
  ReferenceInput,
  AutocompleteInput,
  TextInput,
  ShowButton,
  SimpleList,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import SecuredComponent from "server/security/SecuredComponent";
import { specialistRequests } from "api/specialistApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <ReferenceInput
    source="specializationId"
    reference={specialistRequests.getSpecializationsSelect()}
    alwaysOn
  >
    <AutocompleteInput
      optionText="nameBg"
      label="Специалност"
      fullWidth
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
      style={{ width: 300 }}
    />
  </ReferenceInput>,
  <TextInput
    source="specializationName"
    label="Име на специалност"
    alwaysOn
    style={{ width: 300 }}
  />,
];

const ListSpecializationsCurricula = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Учебни планове"
      filters={filters}
      exporter={false}
      actions={
        <ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageSpecializationsCurricula)} />
      }
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Специалност (БГ)", value: record?.specializationNameBg }]} />
              <MobileListRow fields={[{ label: "Специалност (EN)", value: record?.specializationNameEn }]} />
            </div>
          )}
          secondaryText={() => (
            <MobileListRow
              fields={[
                {
                  label: "Валиден от",
                  value: (
                    <DateField
                      source="validFrom"
                      locales="bg-BG"
                    />
                  ),
                },
              ]}
            />
          )}
          tertiaryText={() => (
            <SecuredComponent>
              <ShowButton label="" />
            </SecuredComponent>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={{
            "& .RaDatagrid-headerCell": {
              textAlign: "left",
            },
          }}
        >
          <TextField
            source="specializationNameBg"
            label="Специалност (БГ)"
            sortable={false}
          />
          <TextField
            source="specializationNameEn"
            label="Специалност (EN)"
            sortable={false}
          />
          <DateField
            source="validFrom"
            label="Валиден от"
            locales="bg-BG"
            sortable={false}
          />
          <SecuredComponent>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListSpecializationsCurricula;
